import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent } from '@ionic/angular/standalone';
import { TemplateSelectorComponent } from '../../../../components/template-selector/template-selector.component';
import { CollectionTemplate } from '../../../collection-template';

@Component({
  selector: 'app-template-select-modal',
  templateUrl: './template-select-modal.component.html',
  styleUrls: ['./template-select-modal.component.scss'],
  standalone: true,
  imports: [
    IonHeader,
    IonToolbar,
    IonButton,
    IonTitle,
    IonContent,
    TemplateSelectorComponent
  ],
})
export class TemplateSelectModalComponent {
  @Input() selectedTemplateId: string | null = null;

  constructor(private modalController: ModalController) {}

  onClose(): void {
    this.modalController.dismiss();
  }

  onTemplateSelected(template: CollectionTemplate): void {
    this.modalController.dismiss({ template });
  }
}
